import { render } from "./FindANiche.vue?vue&type=template&id=1c401bcb"
import script from "./FindANiche.vue?vue&type=script&lang=js"
export * from "./FindANiche.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__